export function isCollection100PercentEnabled(collection100Percent) {
    return collection100Percent === true || collection100Percent === 'true';
}

// only the actual charge (processing) date is restricted; selecting future months is allowed
export function isFutureDate(dateValue, now = new Date()) {
    if (!dateValue) {
        return false;
    }
    const date = new Date(dateValue);
    const today = new Date(now);
    date.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return date > today;
}
